import Logger from 'utils/logging'
import client, { UserServiceClientResponse } from '../client'

export async function getPlexBalance(token: string): Promise<number | 'N/A'> {
    return client.request<UserServiceClientResponse<{balance: number | 'N/A'}>>({
        url: '/plex/balance',
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
        },
        method: 'get',
    })
        .then((result) => {
            if (result?.data?.success) {
                return result.data.data.balance
            }
            return 'N/A'
        })
        .catch((error) => {
            Logger.captureNetworkException(
                error,
                'user/plex/balance',
                'user.plex.balance'
            )
            return 'N/A'
        })
}
